import fetch from 'utils/fetch';

export function otaSyncProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/otaSyncProduct',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/otaSyncProduct.js